import React, { SVGProps } from 'react';

export const Copy = ( props: SVGProps<SVGSVGElement> ) => (
	<svg viewBox='0 0 24 24' { ...props } xmlns='http://www.w3.org/2000/svg'>
		<path
			fill='currentColor'
			d='M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1m3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2m0 16H8V7h11v14Z'
		/>
	</svg>
);
